import React from 'react'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

const CuentaContableFormGroup = ({ iTouched, iError, setFieldValue, iValue }) => {
  const onChange = React.useCallback(
    salida => {
      setFieldValue('cuentaContable', salida.value)
      setFieldValue('cuentaContableInfo', salida.label)
    },
    [setFieldValue]
  )

  const clickClear = React.useCallback(() => {
    setFieldValue('cuentaContable', '')
    setFieldValue('cuentaContableInfo', '')

    setTimeout(() => {
      KeyEventUtil.leaveOnKeyEvent('select-plantillacobranza-cuentaContable')
    }, 200)
  }, [setFieldValue])

  return (
    <Form.Group>
      <Form.Label
        text='CUENTA CONTABLE'
        htmlFor='input-plantillacobranza-cuentaContable'
        md={4}
        alignRightAt='md'
      />
      <Col md={8}>
        {iValue ? (
          <ClearInputGroup
            id='input-plantillacobranza-cuentaContable'
            iValue={iValue}
            clickClear={clickClear}
          />
        ) : (
          <Select2CuentaContable
            id='select-plantillacobranza-cuentaContable'
            onlyAnalitica
            onChange={onChange}
          />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableFormGroup)
